import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import styles from '../styles/sectionLabel.module.scss';

const SectionLabel = ({ children }) => (
  <Typo className={styles.element} element="span" variant="s01">
    {children}
  </Typo>
);

SectionLabel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SectionLabel;
